// Removing internal links (SEO directive)
function navLinkFn(e) {
  e.preventDefault();
  window.location.href = this.getAttribute('data-url');
  console.log(this.getAttribute('data-url'));
}

document.addEventListener('DOMContentLoaded', function() {
  var navLinks = document.getElementsByTagName('data-link'); // Fetch all data-link tags
  for (var i = 0; i < navLinks.length; i++) {
    if (navLinks[i].hasAttribute('data-url')) { // Check if they have a 'data-url' attribute
      navLinks[i].addEventListener('click', navLinkFn); 
    }
  }
});

// Filter dropdown
function setupEventListeners() {
  $("#facets-dropdown-container").off('click').on('click', function(e) {
    e.preventDefault();

    // Toggle open class for filter-dropdown-icon
    $(".filter-dropdown-icon").toggleClass("open");

    // Toggle the dropdown open/close state for facets-dropdown
    const form = $("#facets-dropdown");
    if (form.hasClass("is-open")) {
      form.removeClass("is-open");
    } else {
      form.addClass("is-open");
    }
  });
 }

$(document).ready(function () {   
  setupEventListeners();
  
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      setupEventListeners();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}); 